<template>
  <div
    class="quiz-form-input"
    :class="{
      'quiz-form-input--disabled': type === 'disabled',
      'quiz-form-input--correct': type === 'correct',
      'quiz-form-input--incorrect': type === 'incorrect',
      'quiz-form-input--showCorrectAnswer': type === 'showCorrectAnswer',
      'quiz-form-input--showOtherCorrectAnswer': type === 'showOtherCorrectAnswer'
    }"
  >
    <input
      :value="value"
      @input="updateValue($event.target.value)"
      @keyup.enter="$emit('enterKey')"
      class="quiz-form-input__input"
      :placeholder="$t('typeYourAnswer')"
      :maxlength="limitText"
      ref="type-answer-value"
      :disabled="!!type"
      :class="{'text-colour__white': setTextColourWhite}"
    >
    <div class="quiz-form-input__count">
      {{ limitText - value.length }}
    </div>

    <div class="quiz-form-input__info" v-if="!!type && type !== 'disabled'">
      <div class="quiz-form-input__info-container animate__animated animate__fadeIn animate__faster" v-if="displayUserCount">
        <span class="quiz-form-input__user-count">{{ numberOfUserWithSameAnswer || 0 }}</span>
        <AhaSvg
          name="user-solid"
          view-box="0 0 16 17"
        />
      </div>
      <img
        v-if="type === 'showCorrectAnswer' || type === 'correct'"
        class="quiz-form-input__result-icon"
        src="@/assets/images/result.svg"
        alt="check icon"
      >
      <img
        v-if="type === 'showOtherCorrectAnswer'"
        class="quiz-form-input__result-icon"
        src="@/assets/images/check.svg"
        alt="check icon"
      >

      <img
        v-if="type === 'incorrect'"
        class="quiz-form-input__result-icon"
        src="@/assets/images/result-incorrect.svg"
        alt="check icon"
      >
    </div>
  </div>
</template>
<script>
import AhaSvg from 'storybook-presenter/UI/Svg'
import QuizStatuses from '@/constants/QuizStatuses'

export default {
  components: {
    AhaSvg,
  },
  props: {
    numberOfUserWithSameAnswer: {
      type: Number,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
    value: {
      type: String,
      required: true,
    },
    displayUserCount: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      limitText: 150, // limit input type answer submit
      typeAnswerValue: '',
    }
  },

  computed: {
    setTextColourWhite() {
      return this.$store.state.slide.textColour === '#ffffff' && this.$store.state.slide.quizStatus === QuizStatuses.RESULT_SCREEN &&
      !!this.type && (this.type === 'correct' || this.type === 'incorrect')
    },
  },

  mounted() {
    setTimeout(() => {
      if (this.$refs['type-answer-value']) {
        this.$refs['type-answer-value'].focus()
      }
    }, 100)
  },

  methods: {
    updateValue(value) {
      if (value.length > this.limitText) {
        value = value.substring(0, this.limitText)
        if (this.$refs['type-answer-value']) {
          this.$refs['type-answer-value'].value = value
        }
      }
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss">
  .quiz-form-input {
    position: relative;
    &__input {
      appearance: none;
      -webkit-appearance: none;
      padding: 0 0.5rem;
      padding-right: 2.25rem;
      height: 2.5rem;
      border: 1px solid #D3D7E1;
      border-radius: 0.25rem;
      width: 100%;
      font-size: 14px;

      &:focus, &:hover {
        background-color: #F9FBFF;
        border-color: #348EF6;
        outline: none;
      }
      &.text-colour__white {
        color: #ffffff;
      }
      &:disabled {
        opacity: 1; // fix safari applying opactity to disabled input
        background-color: #fff;
      }
    }

    &__count {
      position: absolute;
      height: 2.5rem;
      top: 0;
      display: flex;
      align-items: center;
      right: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    &__info {
      position: absolute;
      height: 2.5rem;
      top: 0;
      display: flex;
      align-items: center;
      right: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.25rem;

      .quiz-form-input__result-icon {
        margin-left: 12px;
      }
    }

    &__info-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__user-count {
      margin-right: 4px;
      margin-top: 2px;
    }

    &__result-icon {
      width: 20px;
      height: 20px;
    }

    &--correct, &--incorrect, &--showCorrectAnswer, &--showOtherCorrectAnswer {
      .quiz-form-input__input {
        padding-right: 6rem;
      }

      .quiz-form-input__count {
        display: none;
      }
    }

    &--disabled {
      .quiz-form-input__input {
        background-color: #EBEBEB;
        border: 2px solid #D1D1D1;
        color: #707070;
        -webkit-text-fill-color: #707070; // fix input color on safari

        &:focus, &:hover {
          border-color: #D3D7E1;
        }
      }
    }

    &--showCorrectAnswer, &--showOtherCorrectAnswer {
      .quiz-form-input__input {
        color: #707070;
        -webkit-text-fill-color: #707070; // fix input color on safari
        &:focus, &:hover {
          border-color: #D3D7E1;
        }
      }
    }

    &--correct {
      .quiz-form-input__input {
        background-color: rgba(51, 193, 115, 0.5);
        border: 2px solid #33C173;

        &:focus, &:hover {
          border-color: #33C173;
        }
      }

    }

    &--incorrect {
      .quiz-form-input__input {
        background: rgba(255, 73, 84, 0.5);
        border: 2px solid #FF4954;

        &:focus, &:hover {
          border-color: #FF4954;
        }
      }
    }
  }

</style>
